import React from 'react';
import styles from './head-space.module.scss';

const HeadSpace: React.FC = () => (
    <div className={styles.headSpace} />
);

export default React.memo(HeadSpace);
